import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XIcon } from 'lucide-react';
export function WhyFailedSection() {
  const failures = [{
    title: 'Pastillas para dormir',
    desc: 'No te dan descanso real, solo te dejan "inconsciente" y con una pesadez mental que arruina tu mañana.'
  }, {
    title: 'Suplementos de melatonina',
    desc: 'Confunden a tu cerebro y lo vuelven perezoso para producir su propia hormona del sueño.'
  }, {
    title: 'Contar ovejas',
    desc: 'Forzarte a cerrar los ojos solo aumenta el estrés, lo que dispara más cortisol y te mantiene más despierto.'
  }];
  return <section className="py-24 bg-navy-800" data-id="element-336">
      <div className="max-w-5xl mx-auto px-6" data-id="element-337">
        <FadeIn data-id="element-338">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-16" data-id="element-339">
            Por qué lo que has intentado no funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-340">
          {failures.map((item, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-341">
              <div className="bg-navy-900 border border-navy-700 p-8 rounded-sm h-full transition-colors hover:border-navy-600" data-id="element-342">
                <div className="w-10 h-10 rounded-full bg-red-900/20 flex items-center justify-center mb-6" data-id="element-343">
                  <XIcon className="w-5 h-5 text-red-400" data-id="element-344" />
                </div>
                <h3 className="text-xl font-serif mb-4 text-cream" data-id="element-345">
                  {item.title}
                </h3>
                <p className="text-cream-muted text-base leading-relaxed" data-id="element-346">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}